import { Vector3, type Box3, type Camera } from 'three'
import type { ProjectedBounds } from './cityVisibility'

// A board projects to a diamond, not its large enclosing screen rectangle.
// Testing that rectangle hid whole resorts beside and behind the actual board.
export function projectedBoard(camera:Camera){
  return [[-11,-11],[11,-11],[11,11],[-11,11]].map(([x,z])=>new Vector3(x,.6,z).project(camera))
}
type Point={x:number;y:number}
export function projectedBuilding(bounds:Box3,camera:Camera):Point[]{
  const points:Point[]=[]
  for(const x of [bounds.min.x,bounds.max.x])for(const y of [bounds.min.y,bounds.max.y])for(const z of [bounds.min.z,bounds.max.z])points.push(new Vector3(x,y,z).project(camera))
  points.sort((a,b)=>a.x-b.x||a.y-b.y)
  const cross=(o:Point,a:Point,b:Point)=>(a.x-o.x)*(b.y-o.y)-(a.y-o.y)*(b.x-o.x)
  const chain=(list:Point[])=>{const hull:Point[]=[];for(const p of list){while(hull.length>=2&&cross(hull.at(-2)!,hull.at(-1)!,p)<=0)hull.pop();hull.push(p)}hull.pop();return hull}
  return [...chain(points),...chain([...points].reverse())]
}
export function overlapsBoardPolygon(board:Point[],bounds:ProjectedBounds|Point[]){
  const rect=Array.isArray(bounds)?bounds:[{x:bounds.left,y:bounds.bottom},{x:bounds.right,y:bounds.bottom},{x:bounds.right,y:bounds.top},{x:bounds.left,y:bounds.top}]
  const axes=[...board.map((p,i)=>{const q=board[(i+1)%board.length];return {x:-(q.y-p.y),y:q.x-p.x}}),...rect.map((p,i)=>{const q=rect[(i+1)%rect.length];return {x:-(q.y-p.y),y:q.x-p.x}})]
  return axes.every(axis=>{
    const a=board.map(p=>p.x*axis.x+p.y*axis.y),b=rect.map(p=>p.x*axis.x+p.y*axis.y)
    return Math.min(...a)<Math.max(...b)&&Math.min(...b)<Math.max(...a)
  })
}
